/* Service Worker registration with update-available signal.
 * Registers only in production builds (HTTPS) to avoid dev-server hot-reload conflicts.
 */
import { toast } from "sonner";

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Listen for updates.
        reg.addEventListener("updatefound", () => {
          const newSW = reg.installing;
          if (!newSW) return;
          newSW.addEventListener("statechange", () => {
            if (newSW.state === "installed" && navigator.serviceWorker.controller) {
              toast.info("A new version is available — refresh to update.", {
                duration: 8000,
                action: {
                  label: "Refresh",
                  onClick: () => {
                    newSW.postMessage("SKIP_WAITING");
                    window.location.reload();
                  },
                },
              });
            }
          });
        });
      })
      .catch(() => {
        // swallow — SW failure is non-fatal
      });
  });
}

/** Hook into the browser's `beforeinstallprompt` so we can show our own Install CTA. */
export function setupInstallPrompt(onAvailable) {
  if (typeof window === "undefined") return () => {};
  const handler = (e) => {
    e.preventDefault();
    onAvailable(e);
  };
  window.addEventListener("beforeinstallprompt", handler);
  return () => window.removeEventListener("beforeinstallprompt", handler);
}
